module.exports = __webpack_public_path__ + "static/media/peeled_tomatoes_juice.f4a92789.png";